import React from 'react';

import {Grid, Box, Typography} from '@mui/material';
import {any, string} from 'prop-types';

import MultipleAutocompleteRenderer from './MultipleAutocompleteRenderer';
import NumberFieldRenderer from './NumberFieldRenderer';
import SwitchFieldRenderer from './SwitchFieldRenderer';
import {controlPropType, fieldPropType} from '../../../../proptypes-shapes';
import {buildFieldName} from '../buildFieldName';
import FieldLabel from '../field-components/EmmaiFieldLabel/EmmaiFieldLabel';

const SupplierFieldRenderer = ({control, field, watchValues, prefix}) => {
  const enabled = watchValues[field.name]?.enabled || false;

  return (
    <Grid item xs={12}>
      <Grid container>
        <Grid item xs={12} sm={6} pr={1}>
          <FieldLabel required={field.required}>{field.label}</FieldLabel>

          <Grid container alignItems="center" flexWrap="nowrap">
            <Grid item sx={{minWidth: 95}}>
              <SwitchFieldRenderer
                control={control}
                field={{
                  ...field,
                  name: `${field.name}.enabled`,
                  label: ''
                }}
                prefix={prefix}
              />
            </Grid>

            <Grid item width="100%" ml={1} overflow="hidden">
              <MultipleAutocompleteRenderer
                control={control}
                prefix={prefix}
                field={{
                  name: `${field.name}.name`,
                  label: null,
                  placeholder: 'Ex : Nom fournisseur',
                  disabled: !enabled
                }}
              />
            </Grid>
          </Grid>
        </Grid>

        {field.price && field.priceFields && (
          <Grid item xs={12} sm={6}>
            <FieldLabel>{field.priceLabel}</FieldLabel>

            <Box display="flex" gap={0.5} alignItems="center">
              {field.priceFields.map((pf, idx) => (
                <React.Fragment key={pf}>
                  <NumberFieldRenderer
                    control={control}
                    prefix={prefix}
                    field={{
                      name: `${field.priceFieldName}.${pf}`,
                      label: '',
                      placeholder: pf === 'min' || pf === 'child' ? 'Tarif minimum' : 'Tarif maximum',
                      end: field.priceEndAdornment
                    }}
                  />
                  {idx === 0 && field.priceFields.length > 1 && <Typography color="primary">-</Typography>}
                </React.Fragment>
              ))}
            </Box>
          </Grid>
        )}
      </Grid>
    </Grid>
  );
};

SupplierFieldRenderer.propTypes = {
  control: controlPropType.isRequired,
  field: fieldPropType.isRequired,
  watchValues: any,
  prefix: string
};

export default SupplierFieldRenderer;
